module.exports = __webpack_public_path__ + "img/5.06f86e77.png";